import moment from 'moment';

import { ConsumerUsageSummaryQuery } from 'apollo/queries/autogenerate/operations';

// generate sorted "monthly charges breakdown " with additional monthLabel property
export const formatMonthlyCharges = (
  monthlyCharges:
    | ConsumerUsageSummaryQuery['consumerUsageSummary']['monthlyChargesBreakdown']
    | undefined
) => {
  return monthlyCharges
    ? monthlyCharges
        .map((item) => {
          const month = Number(item.billingCycle.split('-')[1]);

          return {
            ...item,
            monthLabel: `${month}月分`,
          };
        })
        .sort(
          (a, b) =>
            moment(a?.billingCycle).unix() - moment(b?.billingCycle).unix()
        )
    : [];
};
